export default __webpack_public_path__ + "media/ab87f12bdb2a69306708f66a72033e38700a1bd63335a860a89f6c5a35d89349.svg";